import { Modal } from "bootstrap";
import { IconText } from "components/IconText";
import { ProBadge } from "components/subscriptions/ProBadge";
import { GlobalContext } from "contexts/GlobalContext";
import { useContext, useRef } from "react";
import { createPortal } from "react-dom";
import { Link, useHistory } from "react-router-dom";
import { RouteList } from "Routes";
import { getModalRoot } from "utils/ModalUtils";
import { PricingTableFeatureData } from "data/PricingTableFeatureData";

export const subscribeModalId = "modal-subscribe";

export const SubscribeModal = () => {
    const { subscribeModal } = useContext(GlobalContext);

    const modalRef = useRef<HTMLDivElement>(null);

    const title = subscribeModal?.title || "Subscribe";

    // on route change close modal
    const history = useHistory();

    history.listen(() => {
        if (modalRef.current) {
            const modal = Modal.getOrCreateInstance(modalRef.current);
            modal.hide();
        }
    });

    return createPortal(
        <div ref={modalRef} className="modal fade" id={subscribeModalId} title={title}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header bg-dark text-white">
                        <h2 className="h4 text-center flex-grow-1 hstack gap-2">
                            <ProBadge disabled={true} />
                            {title}
                        </h2>

                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div className="modal-body vstack gap-3">
                        <div className="hstack gap-3">
                            <div className="h5">Want to use Frankenstories for serious teaching?</div>
                        </div>

                        <div className="vstack gap-1">
                            <div className="h6">Frankenstories Pro gives you:</div>

                            <ul className="mb-0 list-unstyled">
                                {PricingTableFeatureData.filter(x => x.premium).map(f => (
                                    <li className="d-flex align-items-start gap-2" key={f.title}>
                                        <span className="text-success" aria-hidden="true">
                                            <i className="fas fa-check"></i>
                                        </span>

                                        <span dangerouslySetInnerHTML={{ __html: f.title }} />
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="modal-footer border-0 justify-content-start">
                        <Link to={RouteList.Pricing} className="btn btn-primary icon-link">
                            <IconText icon="fas fa-arrow-right" text="View options" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>,
        getModalRoot(),
    );
};
